import { render, staticRenderFns } from "./Form10CaseInformation.vue?vue&type=template&id=7e98985b&scoped=true"
import script from "./Form10CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form10CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e98985b",
  null
  
)

export default component.exports